import styled from 'styled-components';
import { lastMinuteDealsGradient } from '@/app/common/components/Promotions/styled.ts';

export const Container = styled.div`
  text-align: left;
  pointer-events: auto;
`;

export const ContainerFlashSales = styled(Container)<{ $icon: string; $iconSize: number }>`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border-radius: 4px;
  height: 28px;
  padding: 4px 8px 4px 32px;
  font-size: ${({ theme }) => theme.kallisto.font.size['175']};
  line-height: ${({ theme }) => theme.kallisto.font.lineHeight['250']};
  background-color: ${({ theme }) => theme.kallisto.color.common.special.flashSales[400]};
  color: ${({ theme }) => theme.kallisto.color.text.static.textPrimary};
  background-image: url(${({ $icon }) => $icon});
  background-repeat: no-repeat;
  background-position: ${({ $iconSize }) => 16 - $iconSize / 2}px center;
  background-size: ${({ $iconSize }) => $iconSize}px;

  span {
    &:last-child {
      margin-left: 0;
    }
  }
`;

export const ContainerLastminuteDeals = styled(Container)`
  display: inline-flex;
  align-items: center;
  min-height: 28px;
  padding: 4px 8px 4px 8px;
  border-radius: 4px;
  background: ${lastMinuteDealsGradient};

  span {
    margin-top: -2px;

    &:last-child {
      margin-left: 8px;
    }
  }
`;
